import ActivityPageBannerScroll from './ActivityPageBannerScroll'
export default ActivityPageBannerScroll

